import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getValidScenarioListingData } from './../UserFunctions';
import { addScenarioCatalogueDataFromAPI } from './../../actions/scenarioCatalogue/viewAction';
//import { addFilter } from './../../actions/scenarioCatalogue/filterAction';
import Pagination from './../Pagination';
import ScenarioCatalogueTable from './../ScenarioCatalogueTable';
import FilterSidebar from './../scenarioCatalogue/FilterSidebar';
import FilterBubbleOption from './../scenarioCatalogue/FilterBubbleOption';
import SceneGenNavbar from './SceneGenNavbar';
import PropTypes from 'prop-types';

class ViewSceneGenData extends Component {
    constructor(props){
        super(props)
        this.state = {
            toggleSideBar: false
        }
        this.handleToggle = this.handleToggle.bind(this);
        this.logOut = this.logOut.bind(this);
    }


    componentDidMount() {
        getValidScenarioListingData(1).then( (response) => {
            if(response) {
                console.log(response);
                this.props.dispatch(addScenarioCatalogueDataFromAPI(response))
            }else {
                this.props.dispatch(addScenarioCatalogueDataFromAPI({data: [],
                                                                pages: [],
                                                                currentPage: 0}))
            }
        })
    }

    handleToggle() {
        this.setState(( prevState ) => {
            return {
                toggleSideBar: !prevState.toggleSideBar
            }
        })
    }

    logOut() {
        localStorage.removeItem('usertoken');
        this.props.history.push('/')
    }

    filterData() {
        console.log(this.props.scenarioCatalogueData);
        if (_.isEmpty(this.props.filters)) {
            return this.props.scenarioCatalogueData;
        }
        return this.props.scenarioCatalogueData.filter(entry => {
            let matchedFilters = true;
            Object.keys(this.props.filters).forEach(filterKey => {
                if (this.props.filters[filterKey].length) {
                    if(filterKey === "feature_mapping"){
                        matchedFilters = entry[filterKey].toString().includes(this.props.filters[filterKey])
                            ? matchedFilters : false;
                    } else {
                        matchedFilters = this.props.filters[filterKey].includes(entry[filterKey].toString())
                        ? matchedFilters : false;
                    }
                }
            });
            return matchedFilters;
        });
    }


    render() {
        return (
            <div>
                <div id="purple-background">
                    <SceneGenNavbar />
                    <button
                        onClick={this.handleToggle}
                        style={{ marginTop: "1%", backgroundColor: "#464646" }}
                        className="btn"
                    >
                        <i className="fa fa-filter"></i>
                    </button>
                    {this.state.toggleSideBar ? <FilterSidebar handleToggle={this.handleToggle} />: undefined}
                    <div className="container-fluid">
                        <div className="row" style={{ paddingTop: "3%" }}>
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h4 style={{ fontWeight: "bold" }}>Scenario</h4>
                                            </div>
                                            <div>
                                                <FilterBubbleOption />
                                                </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <ScenarioCatalogueTable
                                            scenarioCatalogueData={this.filterData()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.scenarioCatalogueData.length > 0 ?
                         <Pagination
                            currentPage={this.props.currentPage}
                            pages={this.props.pages}
                            getApiInfo={getValidScenarioListingData}
                            action={addScenarioCatalogueDataFromAPI}
                            property={this.props}
                         />
                         : undefined}
                    </div>
                </div>
            </div>
        )
    }
}
ViewSceneGenData.propTypes={
dispatch:PropTypes.string,
history:PropTypes.string,
scenarioCatalogueData:PropTypes.string,
filters:PropTypes.string,
currentPage:PropTypes.string,
pages:PropTypes.string,
}
ViewSceneGenData.defaultProps= {
dispatch:[],
history:[],
scenarioCatalogueData:[],
filters:[],
currentPage:[],
pages:[],
}

const mapStateToProps = (state) => {
    return {
        scenarioCatalogueData: state.viewScenarioCatalogueData.scenarioCatalogue,
        currentPage: state.viewScenarioCatalogueData.currentPage,
        pages: state.viewScenarioCatalogueData.pages,
        filters: state.filters.filters
    }
}

// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };

export default connect(mapStateToProps)(ViewSceneGenData);
